'use strict';

const { ApiClient } = require('../web/api-client');
const AdminApi = require('./admin-api');
const AdminApp = require('./admin-app');

document.addEventListener('DOMContentLoaded', async () => {
  const api = new ApiClient('/admin-api');
  try {
    fetch('/api/runtime', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((runtime) => {
        if (runtime.gameOrigin) document.getElementById('game-link').href = runtime.gameOrigin;
      })
      .catch(() => null);
    const { user } = await api.session();
    document.getElementById('admin-loading').classList.add('hidden');
    if (user.role !== 'ADMIN') {
      document.getElementById('admin-forbidden').classList.remove('hidden'); return;
    }
    document.getElementById('admin-shell').classList.remove('hidden');
    document.getElementById('admin-logout').addEventListener('click', async () => { try { await api.logout(); } finally { location.href = '/admin-login'; } });
    new AdminApp(new AdminApi(api), user).start();
  } catch (error) {
    location.href = '/admin-login';
  }
});
